<div class="feedProduct__slider">
  <vc-feed-product
    *ngFor="let product of activities; let index = index"
    class="feedNI__item"
    [product]="product"
    (click)="seeProduct.emit({product: product, position: index})"
    (likeProduct)="likeProduct.emit({product: product, position: index, isLiked: $event})"
    [isLiked]="likedItems.includes(product.productId)"
  ></vc-feed-product>
  <vc-ref
    *ngIf="totalCardActivities > 4"
    class="feedMore"
    (click)="seeMoreProduct.emit(this.profile.describes.id)"
    [resource]="'/membres/profil-' + profile.describes.url + '.shtml'"
  >
    <div class="feedMore__wrapper">
      <div class="feedMore__wrapper__content vc-text-l">
        <span>+ {{ totalCardActivities - 4 }}</span>
      </div>
      <p class="feedMore__wrapper__cta vc-text-s" i18n="@@NEWSFEED.CARD.NEW_IN.SEE_MORE">
        See more
      </p>
    </div>
  </vc-ref>
</div>
